// @generated by packages/rust/core/examples/gen_ts_palettes.rs -- DO NOT EDIT BY HAND.
// Sources of truth: packages/rust/core/src/palettes.rs (ColorScheme::palette /
// ColorScheme::color_names) and packages/rust/core/src/measured_palettes.rs (CATALOG)
// Regenerate: cargo run --manifest-path packages/rust/core/Cargo.toml --example gen_ts_palettes -- --write
// Drift check (CI): cargo run --manifest-path packages/rust/core/Cargo.toml --example gen_ts_palettes -- --check
//
// Measured RGB values for real e-paper displays, mirrored from the Rust CATALOG so
// TypeScript and Python (which derives its constants from the same CATALOG via FFI at
// import time) can never silently diverge on a recalibration. Key order within each
// palette's `colors` object matches CATALOG's `color_names` order exactly -- it is a
// firmware wire contract (palette index = object key position), not cosmetic.
//
// `scheme` is emitted as a plain numeric literal (not `ColorScheme.XXX`) so this file
// has no import-time dependency on palettes.ts, which re-exports these constants --
// importing back from palettes.ts here would create a circular ES module and risk a
// temporal-dead-zone error. The `ColorPalette.scheme` field's declared type is a plain
// `number` for the same reason; each literal is commented with its enum name.
//
// SCHEME_PALETTES holds the idealized (pure sRGB) palette for every ColorScheme,
// mirrored from the PALETTE_* statics in palettes.rs. The WASM core computes palette
// *indices* from those statics while ditherImage() returns these *colors*, so the two
// must agree entry-for-entry; generating them from one source is what makes that
// guaranteed rather than hoped for. Its keys are plain numeric literals for the same
// no-circular-import reason as `scheme` above.

import type { ColorPalette } from './types';

export const SCHEME_PALETTES: Record<number, ColorPalette> = {
  0: { // ColorScheme.MONO
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
    },
    accent: 'black',
  },
  1: { // ColorScheme.BWR
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      red: { r: 255, g: 0, b: 0 },
    },
    accent: 'red',
  },
  2: { // ColorScheme.BWY
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      yellow: { r: 255, g: 255, b: 0 },
    },
    accent: 'yellow',
  },
  3: { // ColorScheme.BWRY
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      yellow: { r: 255, g: 255, b: 0 },
      red: { r: 255, g: 0, b: 0 },
    },
    accent: 'red',
  },
  4: { // ColorScheme.BWGBRY
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      yellow: { r: 255, g: 255, b: 0 },
      red: { r: 255, g: 0, b: 0 },
      blue: { r: 0, g: 0, b: 255 },
      green: { r: 0, g: 255, b: 0 },
    },
    accent: 'red',
  },
  5: { // ColorScheme.GRAYSCALE_4
    colors: {
      black: { r: 0, g: 0, b: 0 },
      gray1: { r: 85, g: 85, b: 85 },
      gray2: { r: 170, g: 170, b: 170 },
      white: { r: 255, g: 255, b: 255 },
    },
    accent: 'black',
  },
  6: { // ColorScheme.GRAYSCALE_16
    colors: {
      black: { r: 0, g: 0, b: 0 },
      gray1: { r: 17, g: 17, b: 17 },
      gray2: { r: 34, g: 34, b: 34 },
      gray3: { r: 51, g: 51, b: 51 },
      gray4: { r: 68, g: 68, b: 68 },
      gray5: { r: 85, g: 85, b: 85 },
      gray6: { r: 102, g: 102, b: 102 },
      gray7: { r: 119, g: 119, b: 119 },
      gray8: { r: 136, g: 136, b: 136 },
      gray9: { r: 153, g: 153, b: 153 },
      gray10: { r: 170, g: 170, b: 170 },
      gray11: { r: 187, g: 187, b: 187 },
      gray12: { r: 204, g: 204, b: 204 },
      gray13: { r: 221, g: 221, b: 221 },
      gray14: { r: 238, g: 238, b: 238 },
      white: { r: 255, g: 255, b: 255 },
    },
    accent: 'black',
  },
  7: { // ColorScheme.SEVEN_COLOR
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      yellow: { r: 255, g: 255, b: 0 },
      red: { r: 255, g: 0, b: 0 },
      blue: { r: 0, g: 0, b: 255 },
      green: { r: 0, g: 255, b: 0 },
      orange: { r: 255, g: 128, b: 0 },
    },
    accent: 'red',
  },
  8: { // ColorScheme.BWGBRY_SPLIT
    colors: {
      black: { r: 0, g: 0, b: 0 },
      white: { r: 255, g: 255, b: 255 },
      yellow: { r: 255, g: 255, b: 0 },
      red: { r: 255, g: 0, b: 0 },
      blue: { r: 0, g: 0, b: 255 },
      green: { r: 0, g: 255, b: 0 },
    },
    accent: 'red',
  },
  9: { // ColorScheme.GRAYSCALE_8
    colors: {
      black: { r: 0, g: 0, b: 0 },
      gray1: { r: 36, g: 36, b: 36 },
      gray2: { r: 73, g: 73, b: 73 },
      gray3: { r: 109, g: 109, b: 109 },
      gray4: { r: 146, g: 146, b: 146 },
      gray5: { r: 182, g: 182, b: 182 },
      gray6: { r: 219, g: 219, b: 219 },
      white: { r: 255, g: 255, b: 255 },
    },
    accent: 'black',
  },
};

export const SPECTRA_7_3_6COLOR: ColorPalette = {
  scheme: 4, // ColorScheme.BWGBRY
  colors: {
    black: { r: 26, g: 13, b: 35 },
    white: { r: 185, g: 202, b: 205 },
    yellow: { r: 202, g: 184, b: 0 },
    red: { r: 121, g: 9, b: 0 },
    blue: { r: 0, g: 69, b: 139 },
    green: { r: 40, g: 82, b: 57 },
  },
  accent: 'red',
};

export const SPECTRA_7_3_6COLOR_V2: ColorPalette = {
  scheme: 4, // ColorScheme.BWGBRY
  colors: {
    black: { r: 31, g: 24, b: 41 },
    white: { r: 168, g: 180, b: 182 },
    yellow: { r: 180, g: 173, b: 0 },
    red: { r: 113, g: 24, b: 19 },
    blue: { r: 36, g: 70, b: 139 },
    green: { r: 50, g: 84, b: 60 },
  },
  accent: 'red',
};

export const MONO_4_26: ColorPalette = {
  scheme: 0, // ColorScheme.MONO
  colors: {
    black: { r: 5, g: 5, b: 5 },
    white: { r: 220, g: 220, b: 220 },
  },
  accent: 'black',
};

export const BWRY_4_2: ColorPalette = {
  scheme: 3, // ColorScheme.BWRY
  colors: {
    black: { r: 5, g: 5, b: 5 },
    white: { r: 200, g: 200, b: 200 },
    yellow: { r: 200, g: 180, b: 0 },
    red: { r: 120, g: 15, b: 5 },
  },
  accent: 'red',
};

export const BWRY_3_97: ColorPalette = {
  scheme: 3, // ColorScheme.BWRY
  colors: {
    black: { r: 10, g: 7, b: 14 },
    white: { r: 173, g: 178, b: 174 },
    yellow: { r: 172, g: 128, b: 0 },
    red: { r: 85, g: 24, b: 14 },
  },
  accent: 'red',
};

export const SOLUM_BWR: ColorPalette = {
  scheme: 1, // ColorScheme.BWR
  colors: {
    black: { r: 5, g: 5, b: 5 },
    white: { r: 200, g: 200, b: 200 },
    red: { r: 120, g: 15, b: 5 },
  },
  accent: 'red',
};

export const HANSHOW_BWR: ColorPalette = {
  scheme: 1, // ColorScheme.BWR
  colors: {
    black: { r: 5, g: 5, b: 5 },
    white: { r: 200, g: 200, b: 200 },
    red: { r: 120, g: 15, b: 5 },
  },
  accent: 'red',
};

export const HANSHOW_BWY: ColorPalette = {
  scheme: 2, // ColorScheme.BWY
  colors: {
    black: { r: 5, g: 5, b: 5 },
    white: { r: 200, g: 200, b: 200 },
    yellow: { r: 200, g: 180, b: 0 },
  },
  accent: 'yellow',
};
